import React from "react";
import { contactData, siteData } from "../data/mock";
import { Separator } from "./ui/separator";
import { Instagram, Phone, Mail } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative border-t border-slate-800/50">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          {/* Brand */}
          <div>
            <span className="font-bebas text-4xl tracking-wider text-white">AURIE CANO</span>
            <p className="font-nunito text-sm text-white mt-1">{siteData.nickname}</p>
          </div>

          {/* Social */}
          <div className="flex items-center justify-center gap-4">
            <a
              href={contactData.instagram}
              onClick={(e) => {
                e.preventDefault();
                window.open(contactData.instagram, "_blank", "noopener,noreferrer");
              }}
              className="p-2.5 rounded-full border border-black text-black hover:text-teal-300 hover:border-teal-600/50 transition-all duration-300"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href={contactData.tiktok}
              onClick={(e) => {
                e.preventDefault();
                window.open(contactData.tiktok, "_blank", "noopener,noreferrer");
              }}
              className="p-2.5 rounded-full border border-black text-black hover:text-teal-300 hover:border-teal-600/50 transition-all duration-300"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.88-2.88 2.89 2.89 0 012.88-2.88c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.86a8.28 8.28 0 004.76 1.5v-3.4a4.85 4.85 0 01-1-.27z" />
              </svg>
            </a>
            <a
              href={contactData.whatsappLink}
              onClick={(e) => {
                e.preventDefault();
                window.open(contactData.whatsappLink, "_blank", "noopener,noreferrer");
              }}
              className="p-2.5 rounded-full border border-black text-black hover:text-teal-300 hover:border-teal-600/50 transition-all duration-300"
            >
              <Phone className="w-4 h-4" />
            </a>
            <a
              href={`mailto:${contactData.email}`}
              className="p-2.5 rounded-full border border-black text-black hover:text-teal-300 hover:border-teal-600/50 transition-all duration-300"
            >
              <Mail className="w-4 h-4" />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-right">
            <p className="font-nunito text-xs text-white">© {currentYear} Aurie Cano. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
